import Box from '@mui/material/Box';
import {
  purple,
  deepPurple,
  indigo,
  blue,
  lightBlue,
  cyan,
  teal,
  green,
  lightGreen,
  lime,
  yellow,
  amber,
  orange,
  deepOrange,
} from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { FC, useMemo } from 'react';

const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'color' && prop !== 'size',
})<{ color: string; size: number }>(({ color, size }) => ({
  width: `${size}px`,
  height: `${size}px`,
  borderRadius: '2px',
  backgroundColor: color,
  flexShrink: 0,
}));

const MUI_COLORS = [
  blue[500],
  green[500],
  purple[500],
  deepPurple[500],
  indigo[500],
  lightBlue[500],
  cyan[500],
  teal[500],
  lightGreen[500],
  lime[700],
  yellow[700],
  amber[700],
  orange[500],
  deepOrange[500],
];

const hashRecord = (record: Record<string, string | number>): number => {
  const str = Object.keys(record)
    .sort()
    .map((k) => `${k}:${record[k]}`)
    .join(',');
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) % 2147483647;
  }
  return hash % MUI_COLORS.length;
};

type Props = {
  color?: string;
  colorKey?: Record<string, string | number>;
  listIndex?: number;
  size?: number;
  className?: string;
};

const ColorIndicator: FC<Props> = ({
  color,
  colorKey,
  listIndex,
  size = 8,
  className,
}) => {
  const resolvedColor = useMemo(() => {
    if (color) return color;
    if (colorKey !== undefined) return MUI_COLORS[hashRecord(colorKey)];
    if (listIndex !== undefined)
      return MUI_COLORS[listIndex % MUI_COLORS.length];
    return MUI_COLORS[Math.floor(Math.random() * MUI_COLORS.length)];
  }, [color, colorKey, listIndex]);

  return <StyledBox color={resolvedColor} size={size} className={className} />;
};

export default ColorIndicator;
